import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bankIconStyles: { alignSelf: 'center' },
  maskUnmaskStyles: { marginLeft: 8 },
  upDownIconStyles: { alignSelf: 'center', marginRight: 16 },
});

export default styles;
